export var AnalyticsNavigationPage;
(function (AnalyticsNavigationPage) {
    AnalyticsNavigationPage["planner"] = "planner_page";
    AnalyticsNavigationPage["summary"] = "summary_page";
    AnalyticsNavigationPage["landingPage"] = "landing_page";
    AnalyticsNavigationPage["screensaver"] = "screensaver";
    AnalyticsNavigationPage["external"] = "external";
})(AnalyticsNavigationPage || (AnalyticsNavigationPage = {}));
//# sourceMappingURL=AnalyticsNavigationPage.js.map